import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { INTEGRATIONS } from '../../../model/global-configuration.constant';

@Injectable()
export class MapperService extends EditableGridService {

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * Get api value
	 */
	get api():any {
		return this.systemApiService.api;
	}

	/**
	 * Get baseUrl value
	 */
	get baseUrl(): any {
		return `${this.api.orders}/utils/${this.entity === INTEGRATIONS.NEXSYS_DOCUMENT_TYPES ? INTEGRATIONS.NEXSYS : this.entity}`;
	}

	/**
	 * Get base url configuration suffix
	 * @returns string
	 */
	getConfigurationUrlSuffix(): string {
		let configurationSuffix = '';

		switch (this.entity) {
			case INTEGRATIONS.NEXSYS:
			case INTEGRATIONS.NEXSYS_DOCUMENT_TYPES:
				configurationSuffix = `includeNexsysInfo=true`;
				break;
			case INTEGRATIONS.VALUTRUST:
				configurationSuffix = `includeValutrustInfo=true`;
				break;
			case INTEGRATIONS.XPANSE:
				configurationSuffix = `includeXpanseInfo=true`;
				break;
			case INTEGRATIONS.FNC:
				configurationSuffix = `includeFncInfo=true`;
				break;
		}

		return configurationSuffix;
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveConfiguration(config: Array<any>, configType: string): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/${configType}`, config);
	}

	/**
	 * GET - Return the list of the Nexsys property types configuration mappings.
	 */
	getConfiguration(configType: string): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/${configType}?${this.getConfigurationUrlSuffix()}`);
	}

}
